module.exports = __webpack_public_path__ + "img/categoria-4.a5c81de6.png";